<template>
      <div class="day">
        <div
          :class="['header-cell', active ? 'active' : '', checkPensum ? 'checkPensum' : '', 'text-subtitle1', 'text-no-wrap-ellipsis']"
          @click="roomAction()"
          >
          <span v-if="$q.platform.is.desktop">
            <q-btn flat round size="xs" icon="clear" @click="removeRoom"/>
          </span>
          <span v-if="$q.platform.is.desktop">
            {{ myRoom.label }}
          </span>
          <span v-else>
            {{ myRoom.name }}
          </span>
        </div>
        <div class="row">
          <div id="cell" class="col">
            <div
              class="grid-cell"
              v-for="n in 15"
              :key="`${n}`"
              :class="lessonClass(1, n)"
              @click="lessonAction(1, n)"
              >
              {{ lessonText(1, n) }}
            </div>
          </div>
          <div v-if="myRoom.split" class="col">
            <div
              class="grid-cell"
              v-for="n in 15"
              :key="`${n}`"
              :class="lessonClass(2, n)"
              @click="lessonAction(2, n)"
              >
              {{ lessonText(2, n) }}
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DayLessons',
  props: {
    myRoom: {
      type: Object,
      required: true,
      default: null
    },
    roomIndex: {
      required: true,
      default: null
    },
    active: {
      type: Boolean,
      required: true,
      default: false
    },
    myReservationsOld: {
      // type: List,
      required: true,
      default: []
    }
  },

  computed: {
    ...mapGetters('user', ['username', 'signature']),
    ...mapGetters('reservations', ['roomReservations', 'desiredReservations', 'year', 'week', 'weekDay']),
    myDesiredReservations () {
      var _this = this
      return this.desiredReservations.filter(function (el) {
        return el.room === _this.myRoom.name && el.year === _this.year && el.week === _this.week && el.day === _this.weekDay
      })
    },
    myReservations () {
      return this.roomReservations(this.myRoom.name)
    },
    checkPensum () {
      return this.myRoom.locked_lessons.pensum;
    }
  },
  data () {
    return {
      myDesRes: []
    }
  },
  methods: {
    roomAction () {
      if (this.$q.platform.is.desktop) {
        this.$store.dispatch('reservations/setRoom', this.myRoom)
      } else {
        this.$emit('showRoomDialog')
      }
    },
    removeRoom () {
      var _this = this
      var notMyDesiredReservations = this.desiredReservations.filter(function (el) {
        return el.room !== _this.myRoom.name
      })
      this.$store.dispatch('reservations/setDesiredReservations', notMyDesiredReservations)
      this.$emit('removeSelectedRoom', this.myRoom)
    },
    lessonClass (slot, lesson) {
      if (this.isOccupied(slot, lesson)) {
        return ['grid-cell', 'lesson-field', 'occupied']
      } else if (this.isWanted(slot, lesson) && this.active) {
        return ['grid-cell', 'lesson-field', 'wanted']
      } else {
        if (lesson > 12) {
          return ['grid-cell', 'lesson-field', 'night', 'inactive']
        } else {
          return ['grid-cell', 'lesson-field', 'inactive']
        }
      }
    },
    lessonAction (slot, lesson) {
      this.$store.dispatch('reservations/setRoom', this.myRoom)
      if (this.isOccupied(slot, lesson)) {
        for (var n = 0; n < this.myReservations.length; n++) {
          if (this.myReservations[n]['lesson'] === lesson) {
            this.$emit('showReservation', this.myReservations[n])
          }
        }
      } else {
        this.$store.dispatch('reservations/toggleDesiredReservation', { 'room': this.myRoom, 'slot': slot, 'lesson': lesson })
      }
    },
    lessonText (slot, lesson) {
      for (var n = 0; n < this.myReservations.length; n++) {
        if (this.myReservations[n]['lesson'] === lesson && this.myReservations[n]['slot'] === slot) {
          return this.myReservations[n].signature + '/' + this.myReservations[n].course
        }
      }
      if (this.$q.platform.is.mobile) {
        return 'L' + lesson
      } else {
        return 'Lektion ' + lesson
      }
    },
    isOccupied (slot, lesson) {
      for (var n = 0; n < this.myReservations.length; n++) {
        if (this.myReservations[n]['lesson'] === lesson && this.myReservations[n]['slot'] === slot) {
          return true
        }
      }
      return false
    },
    isWanted (slot, lesson) {
      // return this.desiredLessons[lesson - 1]

      var _this = this
      var actReservation = this.myDesiredReservations.filter(function (el) {
        return el.year === _this.year && el.week === _this.week && el.day === _this.weekDay && el.lesson === lesson && el.slot === slot
      })
      return actReservation.length >= 1
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.text-no-wrap-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.day {
  // max-width: 200px;
  // min-width: 200px;
}

.grid-cell {
  padding: 10px 0px;
  text-align: center;
  // background: rgba(86, 61, 124, 0.15);
  border: 1px solid rgba(86, 61, 124, 0.2);
  margin: 1px;
}

.header-cell {
  padding: 10px 0px;
  text-align: center;
  margin: 1px;
  border-top: 1px solid rgba(86, 61, 124, 0.2);
  border-left: 1px solid rgba(86, 61, 124, 0.2);
  border-right: 1px solid rgba(86, 61, 124, 0.2);
  border-bottom: 1px solid rgba(86, 61, 124, 0.2);
  &.active {
    padding: 10px 0px 8px 0px;
    border-bottom: 3px solid $grey-6;
  };
  &.checkPensum {
    background: $red-2;
  }
}

.lesson-field {

  &.occupied {
    background: $red-2;
    border-color: red;
    color: red;
  }

  &.wanted {
    // background: rgba(75, 185, 81, 0.25);
    background: $light-blue-2;
    border-color: $light-blue-10;
    color: $light-blue-10;
  }

  &.available {
    background: $grey-4;
    border-color: black;
    color: rgba(39, 41, 40, 0.65);
  }

  &.inactive {
    background: $grey-2;
    border-color: grey;
    color: rgba(56, 58, 57, 0.65);
  }

  &.night {

  &.occupied {
    background: $red-2;
    border-color: red;
    color: red;
  }

  &.wanted {
    // background: rgba(75, 185, 81, 0.25);
    background: $light-blue-2;
    border-color: $light-blue-10;
    color: $light-blue-10;
  }

  &.available {
    background: $grey-8;
    border-color: black;
    color: rgba(39, 41, 40, 0.65);
  }

  &.inactive {
    background: $grey-8;
    border-color: grey;
    color: white;
    //color: rgba(56, 58, 57, 0.65);
  }
  }
}

</style>
